import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { toObservable, toSignal } from '@angular/core/rxjs-interop';
import { CommunityOwner } from '../../../../interfaces';
import { CommunityLinksStrategyService } from '../../../../services/strategies';
import { filter, switchMap } from 'rxjs/operators';
import { withLoadingState } from '../../../../utils/observable.utils';
import { CommunityLinksComponent } from '../../community-links.component';

@Component({
  selector: 'app-user-community-links',
  templateUrl: './user-community-links.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommunityLinksComponent],
  host: {
    '[style.display]': 'hasLinks() ? "contents" : "none"',
  },
})
export class UserCommunityLinksComponent {
  profile = input<CommunityOwner | null>(null);

  private strategyService = inject(CommunityLinksStrategyService);
  private strategy = this.strategyService.getStrategy('user');

  private userId$ = toObservable(computed(() => this.profile()?.passport_uuid || null));

  private linksState$ = this.userId$.pipe(
    filter(userId => !!userId),
    switchMap(userId => withLoadingState(this.strategy.loadLinks(userId), []))
  );

  private state = toSignal(this.linksState$, {
    initialValue: { data: [], loading: true },
  });

  links = computed(() => this.state().data);
  isLoading = computed(() => this.state().loading);
  hasLinks = computed(() => this.state().loading || this.state().data.length > 0);
}
